/**
 * Height the details banner reserves in the page, published by `PosterContent`
 * on its parent so the out-of-flow poster and trailer shells can match it.
 */
export const BANNER_RESERVED_HEIGHT_PROPERTY = '--detailsBannerReservedHeight'
